<template>
  <div id="matrix-conf-modal" class="modal" v-if="modalShown">
    <!-- マトリクス詳細モーダル -->
    <dd-matrix-dtl-modal
      ref="matrixDtlModalRef"
      :index="index"
      :type="type"
      :rowCount="rowCount"
      :cellCount="cellCount"
      :isNew="isNew"
    />
    <div class="modal-main">
      <div class="title-area">
        <h2 v-if="editData && editData.length > 0">マトリクス参照</h2>
        <h2 v-else>マトリクス設定</h2>
      </div>
      <div class="data-area">
        <ul>
          <li>
            <span class="label">内部キー</span>
            <input type="number" v-if="editData && editData.length > 0" v-model="editData[2]">
            <input type="number" v-else v-model.number="index">
            <!-- <div class="error_message">{{ fieldErrorMessages.supportType }}</div> -->
          </li>
          <li>
            <span class="label">設定種別</span>
            <select v-if="editData && editData.length > 0" v-model="editData[3]">
              <option v-for="mat in matrixList" :key="mat.code" :value="mat.code">{{ mat.label }}</option>
            </select>
            <select v-else v-model="type">
              <option disabled>選択してください</option>
              <option v-for="mat in matrixList" :key="mat.code" :value="mat.code">{{ mat.label }}</option>
            </select>
            <!-- <div class="error_message">{{ fieldErrorMessages.title }}</div> -->
          </li>
          <li v-if="!editData">
            <span class="label">列数(横)</span>
            <input type="number" v-model="cellCount" :disabled="showCell">
          </li>
          <li v-if="!editData">
            <span class="label">行数(縦)</span>
            <input type="number" v-model="rowCount" :disabled="showRow">
          </li>
          <li v-if="showCell && showRow">
            <button class="main_btn" @click="onResetCellRow">行数・列数解除</button>
          </li>
          <li>
            <span class="label">名前</span>
            <input type="text" v-if="editData && editData.length > 0" v-model="editData[4]">
            <input type="text" v-else v-model="name">
            <!-- <div class="error_message">{{ fieldErrorMessages.contents }}</div> -->
          </li>
          <li>
            <span class="label desp_sty">説明</span>
            <textarea rows="5" v-if="editData && editData.length > 0" v-model="editData[5]"></textarea>
            <textarea rows="5" v-else v-model="caption"></textarea>
            <!-- <div class="error_message">{{ fieldErrorMessages.contents }}</div> -->
          </li>
        </ul>
        <button type="button" class="main_btn" @click="onEditMatData(editData)" v-if="editData && editData.length > 0">マトリクスデータ参照</button>
        <button type="button" class="main_btn" @click="onNewMatData" v-else>マトリクスデータ設定</button>
      </div>
      <div class="button-area">
        <button type="button" class="main_btn" @click="onCreate" v-if="editData && editData.length > 0">更新</button>
        <button type="button" class="main_btn" @click="onCreate" v-else>登録</button>
        <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
import * as AppUtil from '../../utils/App'
import {MATRIX_TYPE} from '../../constants/Type'
import {API_URL} from '../../constants/App'
import MatrixDtlModal from '../../components/master/MatrixDtlModal'
export default {
  name: 'MatrixConfModal',
  components: {
    'dd-matrix-dtl-modal': MatrixDtlModal
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      matrixList: MATRIX_TYPE,
      /** 列数 */
      cellCount: null,
      /** 行数 */
      rowCount: null,
      /** 列数入力制御 */
      showRow: true,
      /** 行数入力制御 */
      showCell: false,
      /** 内部キー */
      index: null,
      /** 設定種別 */
      type: null,
      /** 名前 */
      name: null,
      /** 説明 */
      caption: null,
      editData: null,
      isNew: true
    }
  },
  watch: {
    cellCount: function () {
      if (this.cellCount < 2) {
        this.rowCount = null
        this.showRow = true
      } else {
        this.showRow = false
      }
    },
    editData: function () {
      if (this.editData && this.editData.length > 0) {
        this.isNew = false
      } else {
        this.isNew = true
      }
    }
  },
  methods: {
    /** 新規モーダル */
    showNewModal: function () {
      this.clearData()
      this.modalShown = true
    },
    /** 編集モーダル */
    showEditModal: function (data) {
      this.editData = Object.assign([], data)
      this.modalShown = true
    },
    onCreate: function () {
      let payload = {
        matrixId: this.editData && this.editData.length > 0 ? this.editData[0] : null,
        matrixIndex: this.editData && this.editData.length > 0 ? this.editData[2] : this.index,
        matrixType: this.editData && this.editData.length > 0 ? this.editData[3] : this.type,
        matrixName: this.editData && this.editData.length > 0 ? this.editData[4] : this.name,
        matrixCaption: this.editData && this.editData.length > 0 ? this.editData[5] : this.caption,
        matrixDtlList: this.$refs.matrixDtlModalRef.matrixArr
      }
      axios.post(API_URL.MASTER + '/update-matrix-dtl', payload
      ).then(response => {
        this.modalShown = false
        let modalData = {
          messages: this.isNew ? ['登録しました。'] : ['変更しました。'],
          onOk: () => {
            this.$emit('getTableInfoAndAllData')
          }
        }
        AppUtil.showModal(modalData)
      }).catch(error => {
        Api.handleError(error)
      })
    },
    onCancel: function () {
      this.$refs.matrixDtlModalRef.matrixArr = []
      this.modalShown = false
    },
    onNewMatData: function () {
      if (this.cellCount > 1 && this.rowCount > 0) {
        this.showCell = true
        this.showRow = true
        this.$refs.matrixDtlModalRef.createNewTable()
        this.$refs.matrixDtlModalRef.showModal()
        this.$refs.matrixDtlModalRef.matrixArr = []
      } else if (!this.cellCount && !this.rowCount) {
        AppUtil.showModal({
          messages: ['行数は0以上、列数は1以上の値を入れてください']
        })
      } else if (!this.rowCount || this.rowCount.length === 0) {
        AppUtil.showModal({
          messages: ['行数に0以上の値を入れてください']
        })
      } else if (!this.cellCount || this.cellCount.length === 0) {
        AppUtil.showModal({
          messages: ['列数に1以上の値を入れてください']
        })
      }
    },
    onEditMatData: function (data) {
      if (this.$refs.matrixDtlModalRef.matrixArr.length > 0) {
        this.$refs.matrixDtlModalRef.createNewTable()
      } else {
        this.$refs.matrixDtlModalRef.getTable(data[2])
      }
    },
    clearData: function () {
      this.cellCount = null
      this.rowCount = null
      this.showRow = true
      this.index = null
      this.type = null
      this.name = null
      this.caption = null
      this.editData = null
    },
    resetTableData: function () {
      this.cellCount = null
      this.rowCount = null
      this.showCell = false
      this.$refs.matrixDtlModalRef.matrixArr = []
    },
    onResetCellRow: function () {
      AppUtil.showModal({
        messages: ['入力したマトリクスデータもリセットされますがよろしいですか？'],
        modalType: 'confirm',
        onOk: () => {
          this.resetTableData()
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
li{
  margin-bottom: 20px;
  .label{
    min-width: 70px;
    display: inline-block;
    text-align: left;
    font-weight: bold;
  }
  .desp_sty{
    position: relative;
    top: -93px;
  }
  input{
    width: 250px;
  }
  select{
    width: 275px;
  }
}
.data-area {
  padding: 20px;
}
.modal-main{
  max-height: 100%;
}
select{
  width: 196px;
}
textarea{
  resize: none;
  width: 250px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/master/MatrixConfModal.vue